export default "__VITE_ASSET__BHkbN7B7__"